import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { MaterialModule } from '@ebw-monorepo/material';
import { ModalModule } from '@ebw-monorepo/modal';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as _moment from 'moment';

import { ApiListComponent } from './api-list/api-list.component';
import { DynamicCheckboxsComponent } from './filter-table/components/dynamic-checkboxs/dynamic-checkboxs.component';
import { DynamicErrorComponent } from './filter-table/components/dynamic-error/dynamic-error.component';
import { DynamicInputComponent } from './filter-table/components/dynamic-input/dynamic-input.component';
import { DynamicRadioComponent } from './filter-table/components/dynamic-radio/dynamic-radio.component';
import { DynamicSelectComponent } from './filter-table/components/dynamic-select/dynamic-select.component';
import { FieldInputComponent } from './filter-table/components/field-input/field-input.component';
import { FilterTableComponent } from './filter-table/filter-table.component';
import { ListComponent } from './list/list.component';
import { BoolenaPipe } from './pipe/boolean.pipe';
import { SummaryComponentComponent } from './summary-component/summary-component.component';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { TableExpandableRowsComponent } from './table-expandable-rows/table-expandable-rows.component';
import { DynamicToggleComponent } from './filter-table/components/dynamic-toggle/dynamic-toggle.component';

registerLocaleData(localeIt, 'it');

const moment = _moment;

export const DATE_TIME_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    I18NTranslateModule
  ],
  declarations: [
    ApiListComponent,
    ListComponent,
    BoolenaPipe,
    FilterTableComponent,
    FieldInputComponent,
    DynamicErrorComponent,
    DynamicInputComponent,
    DynamicCheckboxsComponent,
    DynamicRadioComponent,
    DynamicSelectComponent,
    SummaryComponentComponent,
    TableExpandableRowsComponent,
    DynamicToggleComponent
  ],
  exports: [
    ListComponent,
    ApiListComponent,
    FilterTableComponent,
    FieldInputComponent,
    DynamicErrorComponent,
    DynamicInputComponent,
    DynamicCheckboxsComponent,
    DynamicRadioComponent,
    DynamicSelectComponent,
    DynamicToggleComponent,
    SummaryComponentComponent,
    TableExpandableRowsComponent
  ],
  //https://material.angular.io/components/datepicker/overview#setting-the-locale-code
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: MAT_DATE_FORMATS, useValue: DATE_TIME_FORMAT }
  ]
})
export class ListModule {}
